import { lazy } from 'react';

export const PropertyCatalogManagementPageAsync = lazy(
    () => import('./PropertyCatalogManagementPage'),
);
